function getFormValues(FormName) {
	const depthInput = document.forms[FormName].Depth.value;
	const areaInput = document.forms[FormName].Area.value;
	const wallsInput = document.forms[FormName].Walls.value;

	const depth = parseFloat(depthInput);
	const area = parseFloat(areaInput);
	const walls = parseFloat(wallsInput);

	if (isNaN(depth) || isNaN(area)) {
	  return null;
	}

	const wallPerimeter = isNaN(walls) ? 0 : walls;
	return { depth: depth, area: area, walls: wallPerimeter };
  }

  function BuildCalculation(FormName) {
	const formData = getFormValues(FormName);

	if (!formData) {
	  return;
	}

	const { depth: depthMm, area: areaSqM, walls: wallPerimeterM } = formData;

	const thicknessConversion = 1000;
	const limeDensity = 1.8;
	const limeRatio = 7;
	const foamWastage = 1.05;
	const geoFactor = 2;

	const insulationThickness = depthMm / thicknessConversion;
	const limeThickness = 0.1;
	const flankThickness = 0.04;

	const insulationConductivity = 0.1;
	const limeConductivity = 0.41;
	const flankConductivity = 0.4;

	const initialU = 0.05 + (1.65 * (wallPerimeterM / areaSqM)) - (0.6 * (wallPerimeterM / areaSqM) * (wallPerimeterM / areaSqM));
	const initialResistance = 1 / initialU;
	const insulationResistance = calculateThermalResistance(insulationThickness, insulationConductivity);
	const limeResistance = calculateThermalResistance(limeThickness, limeConductivity);
	const flankResistance = calculateThermalResistance(flankThickness, flankConductivity);

	const overallU = 1 / (initialResistance + insulationResistance + limeResistance + flankResistance);
	const roundedU = overallU.toFixed(2);
	const roundedInitialU = initialU.toFixed(2);

	const requiredFoamGlass = calculateMaterialRequirement(insulationThickness * areaSqM, foamWastage);
	const requiredGeoTex = calculateMaterialRequirement(areaSqM, geoFactor);
	const requiredLime = calculateMaterialRequirement(areaSqM * limeThickness * limeDensity, limeRatio);
	const requiredSand = calculateMaterialRequirement(areaSqM * limeThickness * limeDensity, 1);
	const requiredGlass = requiredSand;

	updateUI(roundedU, requiredFoamGlass, requiredGeoTex, requiredLime, requiredSand, requiredGlass);
  }

  function calculateThermalResistance(thickness, conductivity) {
	return thickness / conductivity;
  }

  function calculateMaterialRequirement(value, factor) {
	return Math.ceil(value * factor);
  }

  function updateUI(uValue, foam, geo, lime, sand, glass) {
	document.getElementById('UValue').innerHTML = uValue;
	document.getElementById('ReqFoamGlass').innerHTML = foam;
	document.getElementById('ReqGeoTex').innerHTML = geo;
	document.getElementById('ReqLime').innerHTML = lime;
	document.getElementById('ReqSand').innerHTML = sand;
	document.getElementById('ReqGlass').innerHTML = glass;
  }